import { Component } from 'react'
import { Alert } from 'reactstrap'
import DashcamContainer from '../Material/DashcamContainer'
import IncidentSubNav from './IncidentSubNav'
import './Incidents.css'

// Sub-views within the Dashcam tab: the incident-date view (footage from the
// same day as the incident) vs the entire-rental view (all of the rental's
// footage, so the driver's behaviour on other days is visible when there's no
// video for the incident day itself).
const VIEWS = {
    INCIDENT_DATE: "incidentDate",
    ENTIRE_RENTAL: "entireRental",
}

class DashcamTab extends Component {
    constructor(props) {
        super(props)
        this.state = {
            view: VIEWS.INCIDENT_DATE,
            showBanner: true,
        }
    }

    setView = (view) => {
        if (view !== this.state.view) {
            this.setState({ view })
        }
    }

    renderIncidentDateView = () => {
        return (
            <div className="mt-3">
                <DashcamContainer
                    key="dashcam-incident-date"
                    carId={this.props.carId}
                    rentalId={this.props.rentalId || null}
                    incidentDate={this.props.incidentDate || null}
                />
            </div>
        )
    }

    renderEntireRentalView = () => {
        if (!this.props.rentalId) {
            return <Alert color="info" className="mt-3">This incident has no rental attached, so the rental's dashcam records cannot be shown.</Alert>
        }
        return (
            <div className="mt-3">
                <DashcamContainer
                    key="dashcam-entire-rental"
                    carId={this.props.carId}
                    rentalId={this.props.rentalId}
                    incidentDate={null}
                />
            </div>
        )
    }

    render() {
        const { view } = this.state
        // No item counts here (dashcam records aren't counted up-front), so the
        // segments render label-only -- the shared sub-nav omits the count pill.
        const subNavItems = [
            { id: VIEWS.INCIDENT_DATE, label: "Incident Date", icon: "fa-calendar" },
            { id: VIEWS.ENTIRE_RENTAL, label: "Entire Rental", icon: "fa-video-camera" },
        ]
        return (
            <div className="dashcam-tab-container">
                <div className="incident-overview-header">
                    <div className="incident-overview-header__titles">
                        <h3 className="incident-overview-header__title">Dashcam Overview</h3>
                        <p className="incident-overview-header__subtitle">Review incident-day footage or the driver's full rental history</p>
                    </div>
                    <IncidentSubNav items={subNavItems} activeId={view} onSelect={this.setView} />
                </div>
                {this.state.showBanner && (
                    <div className="incident-overview-banner">
                        <span className="incident-overview-banner__icon"><i className="fa fa-video-camera" aria-hidden="true" /></span>
                        <div className="incident-overview-banner__text">
                            <div className="incident-overview-banner__title">Dashcam Footage</div>
                            <div className="incident-overview-banner__desc">
                                Footage is grouped by the incident date and the entire rental. If there's no video for the incident day, switch to Entire Rental to review the driver's behaviour on other days.
                            </div>
                        </div>
                        <button type="button" className="incident-overview-banner__close" onClick={() => this.setState({ showBanner: false })} aria-label="Dismiss">
                            <i className="fa fa-times-circle" aria-hidden="true" />
                        </button>
                    </div>
                )}

                {view === VIEWS.INCIDENT_DATE ? this.renderIncidentDateView() : this.renderEntireRentalView()}
            </div>
        )
    }
}

export default DashcamTab
